function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.09 1.87l.05.02.08.05c.1.06.2.13.29.22l4.34 4.38c.26.26.4.6.4.97v2.93a.81.81 0 11-1.63 0V8.25h-3.5c-.75 0-1.37-.62-1.37-1.38v-3.5H5.37v13.25h3.07a.81.81 0 110 1.63H5.13c-.76 0-1.38-.62-1.38-1.38V3.13c0-.75.62-1.37 1.38-1.37h5.4c.2 0 .38.04.56.12zm4.35 11.88h-2.19v-2.19a.81.81 0 10-1.63 0v2.19H9.56a.81.81 0 100 1.63h2.06v2.06a.81.81 0 101.63 0v-2.07h2.19a.81.81 0 100-1.62zm-4.06-7.13V4.33l2.27 2.3h-2.28z",
  clipRule: "evenodd"
});

function SvgDocumentNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#fff",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentNew);
export default __webpack_public_path__ + "static/media/document-new.5d1ab097.svg";
export { ForwardRef as ReactComponent };